const atualizarImplementos = (state, implementos) => {
    state.implementos = implementos;
}

const atualizarImplemento = (state, implemento) => {
    state.implemento = implemento;
}

export default {
    atualizarImplementos,
    atualizarImplemento
}